// Bro mellem CookieConsent v3 og Shopify Customer Privacy API → Swym

function swymSyncConsent() {
  var prefs = window.CookieConsent?.getUserPreferences();
  var privacy = window.Shopify?.customerPrivacy;
  if (!prefs || !privacy?.setTrackingConsent) return;

  privacy.setTrackingConsent(
    {
      preferences: prefs.acceptedCategories.includes('functionality'),
      analytics:   prefs.acceptedCategories.includes('analytics'),
      marketing:   prefs.acceptedCategories.includes('marketing'),
    },
    function() {
      document.dispatchEvent(new CustomEvent('visitorConsentCollected'));
    },
    function(err) { console.warn('[Consent Bridge]', err); }
  );
}

window.addEventListener('cc:onConsent', swymSyncConsent);
window.addEventListener('cc:onChange', swymSyncConsent);

document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-swym-add-to-wishlist], .swym-button, .swym-button_product, .swym-add-to-wishlist');
  if (!btn) return;

  var prefs = window.CookieConsent?.getUserPreferences();
  var hasConsent = prefs?.acceptedCategories?.includes('functionality');

  if (!hasConsent) {
    e.preventDefault();
    e.stopImmediatePropagation();
    window.CookieConsent?.showPreferences();
  }
}, true);